
import { useDispatch, useSelector } from "react-redux";

import { removeImageFromPath, uploadFileToServer } from "../../../components/Forms/FormHandler.jsx";
import { toast } from "react-toastify";
import ConfigGuestCountUi from "./GuestCountUi.jsx";
import { GET_SYSTEM_CONFIG, SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { get } from "../../../../store/actions/CommonActions.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";

const ConfigGuestCount = () => {
    const data = useSelector((state) => state.systemconfig);
    const dispatch = useDispatch();
    let initialValues = {
        guest_count: 0
    };
    // console.log('svnisoevnsev', data)
    if (data) {
        initialValues = {
            ...data
        }
    }
    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            if (values.banner instanceof File) {
                const file = values.banner;
                try {
                    // 🔍 upload file
                    const url = await uploadFileToServer(file);
                    // console.log('svnioevs', url);
                    values.banner = url;
                } catch (err) {
                    toast.error("Error uploading file");
                    console.error(err);
                    return; // stop submit
                }
            } else if (values.banner == "" && initialValues.banner != "") {
                await removeImageFromPath(initialValues.banner);
            }
            let method = "post";
            let endpoint = `configs`;
            // console.log("snvuisbevsevsdvs");
            if (values?._id) {
                method = "put";
                endpoint = `configs/${values?._id}`;
            }
            const response = await apiCaller({ method, data: values, url: endpoint })
                .then((response) => {
                    //   dispatch(confirmedUpdatePostAction(post));
                    // history.push(backUrl);
                    // console.log('snvioesev', response);
                    return response;
                })
                .catch((error) => {
                    console.log("anvuoinsevsev", error);
                    throw error;
                });
            localStorage.setItem('systemconfigs', JSON.stringify(response?.data?.data));
            dispatch({ type: SET_SYSTEM_CONFIG, payload: response?.data?.data });
            setSubmitting(false);
        } catch (error) { }
    };

    return (
        <ConfigGuestCountUi
            handleFormSubmit={handleFormSubmit}
            initialValues={initialValues}
        />
    );
};

export default ConfigGuestCount;
